export enum Modules {
  EXPERIMENTS = 'experiments',
  SIMULATOR = 'simulator',
  SETTINGS = 'settings',
  SORT = 'sort'
}
